import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"

import "./App.vue?vue&type=style&index=0&id=c3b0f79a&lang=less"
import "./App.vue?vue&type=style&index=1&id=c3b0f79a&lang=less"

const __exports__ = script;

export default __exports__